module.exports = __webpack_public_path__ + "img/sand-dune-decal-10.dea970c6.png";